<template>
  <i-col :xl="3" :md="4" :sm="6" :xs="24" class="card-column">
    <Card dis-hover class="partner-item-card">
      <a :href="trim(link)" rel="noopener noreferrer" target="_blank">
        <h3>{{name}}</h3>
      </a>
    </Card>
  </i-col>
</template>
<script>
export default {
  name: 'partner-item',
  props: ['id', 'name', 'link', 'image'],
  methods: {
    trim(link) {
      if (link.includes('https://') || link.includes('http://')) {
        return link.trim();
      }
      return `https://${link.trim()}`;
    },
  },
};
</script>
<style lang="scss">
.partner-item-card {
  display: -webkit-box;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
  min-width: 100px;
  img {
    height: 150px;
  }
  a {
    color: #10a995;
    &:visited,
    &:focus,
    &:active {
      color: #10a995;
    }
    &:hover {
      color: #10a995;
    }
  }
}
.partner-image {
  object-fit: cover;
  width: 100%;
}
@media only screen and (max-width: 576px) {
  .card-column {
    margin: 7.5px 0;
    &:first-child {
      margin-top: 0;
    }
    &:last-child {
      margin-bottom: 0;
    }
  }
}
</style>
